<main *ngIf="dashboardData" class="addp-dashboard-page">
  <h1>{{dashboardData.title}}</h1>

  <div *ngIf="apiError">
    <div class="dashboard-error-box">
      <div class="alert valign-children-middle">
        <div class="alert-error" role="img" aria-label="Error">
          <i class="icon-badgealert"></i>
        </div>
        <div>
          <h4>{{dashboardData.note}}</h4>
          <span>{{dashboardData.apiError}}</span>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="fanStatus">
    <h2>{{dashboardData.customerName}}</h2>
    <p *ngIf="dashboardData.useMock">Scenarios for Demo:
      <select #scenarios (change)="initPage(scenarios.value)">
        <option value="0">Initial Signup</option>
        <option value="1">Signup In Progress</option>
        <option value="2">Error In Signup</option>
        <option style='display:none' value="3">Awaiting Setup</option>
        <option value="4">Setup In Progress</option>
        <option value="5">Setup Completed</option>
        <option value="6">Enrollment In Progress</option>
        <option value="7">Error In Enrollment</option>
        <option value="8">Multi Fan Enrolled / Apple Certificate not Installed</option>
        <option value="9">Single Fan Enrolled / Apple Certificate Expired</option>
      </select>
    </p>
    <h4>{{dashboardData.subTitle}}</h4>

    <div *ngIf="showData" class="row addp-dashboard-container" id="addp-dashboard-container">
      <div class="col-sm-12 col-md-4 col-md-size" *ngIf="fanStatus.initialSignupStatus !== 'Completed' || (fanStatus.initialSignupStatus === 'Completed' && fanStatus.noOfFans > 1)">
        <div class="container fan-status-container">
          <div class="inside-container">
            <h4>{{dashboardData.manageDeployment.title}}</h4>

            <div *ngIf="fanStatus.initialSignupStatus === 'Not Signed Up'">
              <p>{{dashboardData.manageDeployment.firstTimeUser}}</p>
              <div class="dashboard-button-container">
                <button (click)="navigate('welcome')" class="btn btn-secondary"
                [checkRole]="dashboardData.fieldPermissions.welcome"  type="button">{{dashboardData.button.initialSignup}}</button>
              </div>
            </div>

            <div *ngIf="fanStatus.initialSignupStatus === 'PROCESSING'">
              <p>{{dashboardData.manageDeployment.signUpProcess}}</p>
            </div>

            <div *ngIf="fanStatus.initialSignupStatus === 'Error'">
              <div *ngIf="fanStatus.initialSignupStatus === 'Error'" class="dashboard-error-box">
                <div class="alert valign-children-middle">
                  <div class="alert-error" role="img" aria-label="Alert">
                    <i class="icon-badgealert"></i>
                  </div>
                  <div>
                    <h4>{{dashboardData.note}}</h4>
                    <span *ngIf="fanStatus.initialSignupStatus === 'Error'">{{dashboardData.manageDeployment.error}}</span>
                    <span *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">{{dashboardData.deviceInventory.error}}</span>
                  </div>
                </div>
              </div>
              <div class="dashboard-button-container">
                <button (click)="navigate('signup')"  class="btn btn-secondary" 
                [checkRole]="dashboardData.fieldPermissions.signup" type="button">{{dashboardData.button.retrySignup}}</button>
              </div>
            </div>

            <div *ngIf="fanStatus.initialSignupStatus === 'Completed' && chartData.accounts">
              <p class="initial-text">{{dashboardData.manageDeployment.foundationAccounts}}</p>
              <p *ngIf="fanStatus.deviceEnrolledStatus === 'Completed'">{{dashboardData.manageDeployment.deviceEnrolledContent}}</p>
              <p *ngIf="fanStatus.deviceEnrolledStatus !== 'Completed'">{{dashboardData.manageDeployment.setupIncompleteContent}}</p>
              <div>
                <div class="donut-chart-container text-center">
                  <app-donut-chart [data]="chartData.accounts" [r]='chartRadius' [label]="chartLabel.accounts" [stroke_width]='strokeWidth'>
                  </app-donut-chart>
                </div>
                <div class="donut-chart-legend-container row">
                  <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.left"></app-legend>
                  <app-legend class="col-sm-6 col-md-6" [data]="legendData.accounts.right"></app-legend>
                </div>
              </div>

              <div class="apple-cert text-center" *ngIf="fanStatus.appleCertificate != 'Installed'">
                <div class="text-center">
                  <i *ngIf="appleInstalled != 'Apple certificate installed'" class="icon-alert ico" role="img" aria-label="Alert"></i>
                  <a [checkRole]="dashboardData.fieldPermissions.appleCertificate" routerLink="/appleCertificate">{{dashboardData.appleCertificate[fanStatus.appleCertificate]}}</a>
                </div>
              </div>

              <div class="text-center remove-account">
                <a [checkRole]="dashboardData.fieldPermissions.cancelParticipation" routerLink="/cancelParticipation">{{dashboardData.cancelParticipation}}</a>
              </div>

              <div class="dashboard-button-container">
                 <button (click)="navigate('manageInventory')" class="btn btn-secondary show-desktop" type="button">{{dashboardData.button.manageFan}}</button>
                <button (click)="navigate('manageInventory')" class="btn btn-secondary show-mobile" type="button">{{dashboardData.button.manageFanMobile}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-md-size" *ngIf="fanStatus.initialSignupStatus === 'Completed'">
        <div class="container device-status-container">
          <div class="inside-container">
            <h4>{{dashboardData.deviceInventory.title}}</h4>

            <div *ngIf="fanStatus.deviceEnrolledStatus === 'Not Enrolled'">
              <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p>
              <p>{{dashboardData.deviceInventory.initialNotEnrolledDevice}}</p>
              <div class="dashboard-button-container">
                <button (click)="navigate('manageInventory')" class="btn btn-secondary show-desktop" type="button">{{dashboardData.button.enrolledDevice}}</button>
                <button (click)="navigate('manageInventory')" class="btn btn-secondary show-mobile" type="button">{{dashboardData.button.enrolledDeviceMobile}}</button>
              </div>
            </div>

            <div *ngIf="fanStatus.deviceEnrolledStatus === 'PROCESSING'">
              <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p>
              <p>{{dashboardData.deviceInventory.enrollmentProcess}}</p>
            </div>
            <div *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">
              <div *ngIf="fanStatus.deviceEnrolledStatus === 'Error'" class="dashboard-error-box">
                <div class="alert valign-children-middle">
                  <div class="alert-error" role="img" aria-label="Error">
                    <i class="icon-badgealert"></i>
                  </div>
                  <div>
                    <h4>{{dashboardData.note}}</h4>
                    <span *ngIf="fanStatus.initialSignupStatus === 'Error'">{{dashboardData.manageDeployment.error}}</span>
                    <span *ngIf="fanStatus.deviceEnrolledStatus === 'Error'">{{dashboardData.deviceInventory.error}}</span>
                  </div>
                </div>
              </div>

              <!--    <p class='device-hide initial-text'>{{dashboardData.deviceInventory.enrolledDevice}}</p>
              <p>{{dashboardData.deviceInventory.deviceState}}</p>
            <div class="donut-chart-container text-center">
                <app-donut-chart [data]="chartData.error" [r]='chartRadius' [error]=true [label]="chartLabel.error" [stroke_width]='strokeWidth'>
                </app-donut-chart>
              </div> -->
              <div class="dashboard-button-container">
                <button (click)="navigate('manageInventory')" class="btn btn-secondary" type="button">{{dashboardData.button.retryDeviceSetup}}</button>
              </div>
            </div>
            <div *ngIf="fanStatus.deviceEnrolledStatus === 'Completed' && chartData.devices">
              <p class="initial-text">{{dashboardData.deviceInventory.enrolledDevice}}</p>
              <p>{{dashboardData.deviceInventory.setupCompleted}}</p>
              <div>
                <div class="donut-chart-container text-center">
                  <app-donut-chart [data]="chartData.devices" [r]='chartRadius' [label]="chartLabel.devices" [stroke_width]='strokeWidth'>
                  </app-donut-chart>
                </div>
                <div class="donut-chart-legend-container row">
                  <app-legend class="col-sm-6 col-md-6" [data]="legendData.devices.left"></app-legend>
                  <app-legend class="col-sm-6 col-md-6" [data]="legendData.devices.right"></app-legend>
                </div>
              </div>
              <div class="apple-cert text-center" *ngIf="fanStatus.appleCertificate != 'Installed' && dashboardData.appleCertificate[fanStatus.appleCertificate] && fanStatus.noOfFans === 1">
                <div class="text-center">
                  <i *ngIf="appleInstalled != 'Apple certificate installed'" class="icon-alert ico" role="img" aria-label="Alert"></i>
                  <a [checkRole]="dashboardData.fieldPermissions.appleCertificate" routerLink="/appleCertificate">{{dashboardData.appleCertificate[fanStatus.appleCertificate]}}</a>
                </div>
              </div>
              <div class="dashboard-button-container" *ngIf="fanStatus.noOfFans > 1">
                <button (click)="navigate('manageInventory')" class="btn btn-secondary" type="button">{{dashboardData.button.viewDetail}}</button>
              </div>
              <div class="dashboard-button-container" *ngIf="fanStatus.noOfFans <= 1">
                <button (click)="navigate('deviceInventory')" class="btn btn-secondary" type="button">{{dashboardData.button.manageDevice}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 col-md-size" *ngIf="fanStatus.initialSignupStatus === 'Completed'">
        <div class="container report-container">
          <div class="inside-container">
            <h4>{{dashboardData.report.title}}</h4>
            <p class='device-hide initial-text'>{{dashboardData.report.downloadUserReport}}</p>
            <p>{{dashboardData.report.content}}</p>
            <div class="dashboard-button-container">
              <button [checkRole]="dashboardData.fieldPermissions.report" (click)="navigate('manageInventory')" class="btn btn-secondary"
                type="button">{{dashboardData.button.getReport}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>